import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import OrderFilterDialogWrapper from "./FilterDialog/OrderFilterDialogWrapper";


type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const OfflineOrderListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  const navigate = useNavigate();
  const [openFilterDialog, setOpenFilterDialog] = useState<boolean>(false);
  return (
    <SideNavLayout>
            <div className="flex flex-col h-full p-4">
        {/* Page Header */}

        <div className="p-4">
          <ATMPageHeader
          moduleName="ORDER"
            pageTitle="Orders"
            isFilter
            searchValue={searchValue}
            onFilterClick={()=>setOpenFilterDialog(true)}
            onSearchChange={setSearchValue}
            buttonProps={{
              btnName: "Add New",
              onClick: () => {
                navigate("add");
              },
            }}
          />
        </div>

        {/* Table */}
        <div className="flex-1 overflow-auto flex flex-col">
          <ATMTable
            columns={columns}
            rows={rows}
            rowExtraClasses={() => "min-h-[40px]"}
            onRowClick={(row: any) =>
              navigate(`edit/${row?._id}/order-deatils`)
            }
            isLoading={isTableLoading}
          />
        </div>
        <div className="p-4 py-2 flex justify-end">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
        {openFilterDialog ? <OrderFilterDialogWrapper onClose={()=>{setOpenFilterDialog(false)}} /> : null}
      </div>
    </SideNavLayout>
  );
};

export default OfflineOrderListing;
